<template>
  <div
    v-if="featuredProducts"
    id="featured-products"
    :style="`background:${theme && theme.featured_products_background_color ? theme.featured_products_background_color : ''}`"
  >
    <ScrollingBanner :offset="offset" :speed="featuredProducts && featuredProducts.length > 20 ? 1 : 3">
      <div v-for="product in featuredProducts" :key="product.id" class="product-container">
        <div class="d-flex justify-content-center w-100" style="min-width: max-content">
          <FeaturedProductItem
            :product="product"
            :theme="theme"
            :hide-prices="hidePrices"
            @view-product="(product) => $emit('view-product', product)"
          />
        </div>
        <div class="seperator" :style="`background:${theme ? theme.featured_products_border_color : ''}`" />
      </div>
    </ScrollingBanner>
  </div>
</template>

<script>
import FeaturedProductItem from "./FeaturedProductItem.vue";
import ScrollingBanner from "@/components/animated/ScrollingBanner.vue";

export default {
  components: {
    FeaturedProductItem,
    ScrollingBanner,
  },
  props: {
    theme: { type: Object, required: true },
    products: { type: Array, requried: true },
    hidePrices: { type: Boolean, default: false },
    sidebarShowing: { type: Boolean, default: false },
  },
  emits: ["view-product"],
  data() {
    return {
      debug: true,
      lifecycle: undefined,
      scroll: {
        length: 3,
        auto: true,
        max: undefined,
        position: 0,
      },
    };
  },
  computed: {
    featuredProducts() {
      return this.products.reduce((store, product) => {
        if (product.featured) {
          store.push(product);
        }
        return store;
      }, []);
    },
    offset() {
      if (this.sidebarShowing) {
        return 300;
      }
      return 0;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
#featured-products {
  display: flex;

  .product-container {
    display: grid;
    width: max-content;
    align-items: center;
    position: relative;

    .seperator {
      position: absolute;
      border-radius: 1rem;
      height: 75%;
      width: 2px;
      right: -1px;
      opacity: 25%;
    }
  }
}
</style>
